<script>
/**
 * 品控（自 vancheen-b2b 的 QualityView.vue 移植为 Vue 2 版本）
 * 结构：page-hero → 品控理念（分栏，图在右）→ 8 步流程 → 认证徽标 → CTA
 */
import NhShell from '../components/NhShell.vue'
import NhCtaBand from '../components/NhCtaBand.vue'
import NhPageHero from '../components/NhPageHero.vue'
import NhQcProcess from '../components/NhQcProcess.vue'
import NhSectionHead from '../components/NhSectionHead.vue'
import NhSvgIcon from '../components/NhSvgIcon.vue'
import { getSite } from '../nh-site-data'
import { t, setPageTitle } from '../nh-i18n'

export default {
  name: 'NhQualityPage',
  components: {
    NhShell,
    NhCtaBand,
    NhPageHero,
    NhQcProcess,
    NhSectionHead,
    NhSvgIcon
  },
  computed: {
    QC_INTRO() {
      return getSite('QC_INTRO')
    },
    QC_STEPS() {
      return getSite('QC_STEPS')
    },
    QC_BADGES() {
      return getSite('QC_BADGES')
    },
    CTA_QUALITY() {
      const cta = getSite('CTA')
      return cta ? cta.quality : { title: '', desc: '', actions: [] }
    }
  },
  mounted() {
    setPageTitle('quality')
  },
  methods: {
    t
  }
}
</script>

<template>
  <NhShell>
    <NhPageHero
      :crumbs="[{ label: t('crumbs.home'), to: '/' }, { label: t('quality.crumb') }]"
      :title="t('quality.title')"
      :desc="t('quality.desc')"
    />

    <!-- ===== 8 步流程 ===== -->
    <section class="section bg-gray">
      <div class="container">
        <NhSectionHead :kicker="t('quality.processKicker')" :title="t('quality.processTitle')" />
        <NhQcProcess :steps="QC_STEPS" />
      </div>
    </section>

    <!-- ===== 认证与标准 ===== -->
    <section class="section">
      <div class="container">
        <NhSectionHead :kicker="t('quality.certKicker')" :title="t('quality.certTitle')" />
        <div class="qc-badges">
          <div
            v-for="(badge, i) in QC_BADGES"
            :key="badge"
            v-reveal="i || undefined"
            class="qc-badge"
          >
            <NhSvgIcon name="shield" />{{ badge }}
          </div>
        </div>
        <div v-reveal class="text-center mt-40">
          <p style="color:var(--text-mid); max-width:620px; margin:0 auto 20px;">
            {{ t('quality.certNote') }}
          </p>
        </div>
      </div>
    </section>

    <!-- ===== CTA ===== -->
    <NhCtaBand
      :title="CTA_QUALITY.title"
      :desc="CTA_QUALITY.desc"
      :actions="CTA_QUALITY.actions"
    />
  </NhShell>
</template>
